/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentConfigurationResponse
 */
export interface EquipmentConfigurationResponse {
    /**
     * 
     * @type {number}
     * @memberof EquipmentConfigurationResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentConfigurationResponse
     */
    manufacturerId?: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentConfigurationResponse
     */
    manufacturerName?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentConfigurationResponse
     */
    name?: string;
}

/**
 * Check if a given object implements the EquipmentConfigurationResponse interface.
 */
export function instanceOfEquipmentConfigurationResponse(value: object): value is EquipmentConfigurationResponse {
    return true;
}

export function EquipmentConfigurationResponseFromJSON(json: any): EquipmentConfigurationResponse {
    return EquipmentConfigurationResponseFromJSONTyped(json, false);
}

export function EquipmentConfigurationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentConfigurationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'manufacturerName': json['manufacturerName'] == null ? undefined : json['manufacturerName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EquipmentConfigurationResponseToJSON(json: any): EquipmentConfigurationResponse {
    return EquipmentConfigurationResponseToJSONTyped(json, false);
}

export function EquipmentConfigurationResponseToJSONTyped(value?: EquipmentConfigurationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'manufacturerId': value['manufacturerId'],
        'manufacturerName': value['manufacturerName'],
        'name': value['name'],
    };
}

